
import Divider from 'vux/src/components/divider/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
props: ['vos'],
components: {
Popup,
Divider,
XButton
},
data() {
return {
show: false,
shareTitle: '',
shareContent: '',
shareImg: '',
demandId: ''
}
},
methods: {



toShare() {
this.show = true
},
initShareData() {
this.shareTitle = `中国社会帮扶网，让爱在阳光下连接-${
this.vos.region_name.indexOf('县') > 0
? this.vos.region_name.split('县')[0] + '县'
: this.vos.region_name.split('市')[0] + '市'
}的需求${this.vos.demand_title}`
this.shareContent = this.vos.demand_coment
this.shareImg = this.vos.imgUrl[0]
this.demandId = this.vos.id
},

},
watch: {
vos() {
this.initShareData()
}
}
}



// WEBPACK FOOTER //
// ./src/components/share/share.vue